"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
var onSubjectConversationSelectedAction_1 = require("../actions/onSubjectConversationSelectedAction");
exports.default = satcheljs_1.mutator(onSubjectConversationSelectedAction_1.default, function (actionMessage) {
    store_1.default.selectedConversationId = actionMessage.conversationId;
});
//# sourceMappingURL=subjectConversationSelectedMutator.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-subject-picker-store/lib/mutators/subjectConversationSelectedMutator.js
// module id = 2155
// module chunks = 2 3 4 45 108